import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import messages from './local/index';

/** Languages the UI ships, with their native names for the switcher. */
export const SUPPORTED_LANGUAGES = [
  { code: 'en', name: 'English', nativeName: 'English' },
  { code: 'hi', name: 'Hindi', nativeName: 'हिन्दी' },
  { code: 'ta', name: 'Tamil', nativeName: 'தமிழ்' },
  { code: 'te', name: 'Telugu', nativeName: 'తెలుగు' },
  { code: 'kn', name: 'Kannada', nativeName: 'ಕನ್ನಡ' },
  { code: 'bn', name: 'Bengali', nativeName: 'বাংলা' },
] as const;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // No hard-coded `lng`: the detector reads the saved choice from
    // localStorage (key i18nextLng) and falls back to English. Pinning lng
    // here would have silently overridden the user's saved language on every
    // load — the web equivalent of the Flutter LocaleController not persisting.
    fallbackLng: 'en',
    supportedLngs: SUPPORTED_LANGUAGES.map((l) => l.code),
    debug: false,
    resources: messages,
    // Keys are flat and dotted ('bill.settle'), matching the Flutter apps, so
    // the two platforms share one translation contract. Turn OFF i18next's
    // default '.'/':' splitting or it would look for a nested `bill: { settle }`
    // and every lookup would miss.
    keySeparator: false,
    nsSeparator: false,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;